import { noAccessStrictlyConfidential } from "ApiConstraints";
import { WorkingDocumentModel } from "models/WorkingDocumentModel";

import { DisplayDocumentLink } from "./DisplayDocumentLink";

interface DisplayDocumentProps {
  value?: WorkingDocumentModel;
}

export const DisplayDocument: React.FC<DisplayDocumentProps> = ({ value }) => {
  if (value == undefined) {
    return null;
  }

  const { storageUrl } = value;
  if (storageUrl === noAccessStrictlyConfidential) {
    const itemToSet = { ...value };
    itemToSet.canDownload = false;
    value = itemToSet;
  }

  return <DisplayDocumentLink value={value} />;
};
